import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import styles from './Welcome.module.scss';
import i18n from '../../language/i18n';
import axiosClient from '../../libs/axiosClient';
import { setToken } from '../../auth/auth';
import { GOOGLE_AUTH_URL } from '../../auth/Google';
import { LINE_AUTH_URL } from '../../auth/Line';
import calendarAndHopitalLogo from '../../assets/hospitalReservation/calendarAndHospitalLogo.png';
import japanFlag from '../../assets/hospitalReservation/japanFlag.png';
import chinaFlag from '../../assets/hospitalReservation/chinaFlag.png';
import arabFlag from '../../assets/hospitalReservation/arabFlag.png';
import ukFlag from '../../assets/hospitalReservation/ukFlag.png';
import lineIcon from '../../assets/hospitalReservation/lineIcon.png';
import wechatIcon from '../../assets/hospitalReservation/wechatIcon.png';
import whatsappIcon from '../../assets/hospitalReservation/whatsappIcon.png';
import googleIcon from '../../assets/hospitalReservation/googleIcon.png';

interface WelcomeProps {
  fcmToken: string | null;
}

function Welcome({ fcmToken }: WelcomeProps) {
  const [selectedTab, setSelectedTab] = useState('consultation');
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  let redirectURL = new URLSearchParams(window.location.search).get('rurl');
  
  const isFormValid = id.trim() !== "" && pw.trim() !== "";
  
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const formData = new FormData();
    formData.append('username', id);
    formData.append('password', pw);
    
    if (fcmToken) {
      formData.append('device_token', fcmToken);
    }

    axiosClient
      .post(
        '/api/v1/auth/login',
        formData,
        { withCredentials: true }
      )
      .then((res) => {
        setToken(res.data);
        // if (redirectURL && redirectURL !== '/join')
        //   window.location.href = redirectURL;
        // else 
        window.location.href = '/';
        // alert("로그인 성공");
      })
      .catch((err) => {
        alert("Login Failed");
        // navigate("/login");
        console.log(err.response.data);
      });
  }

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
  };

  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const handleLanguageSelect = (language: any) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language);
    localStorage.setItem('selectedLanguage', language);
  };

  useEffect(() => {
    const localToken = localStorage.getItem('token');
    if (localToken) navigate(-1);
  }, []);

  const renderRightPanelContent = () => {
    if (!selectedLanguage) {
      return (
        <>
          <div className={styles.topSpacer}></div>
          <h2>Welcome to the K-Beauty!</h2>
          <p>Choose your language</p>
          <ul className={styles.languageList}>
            <li onClick={() => handleLanguageSelect('en')}>
              {/* <img src={ukFlag} alt="UK Flag" /> */}
              English
            </li>
            <li onClick={() => handleLanguageSelect('zh')}>
              {/* <img src={chinaFlag} alt="Chinese Flag" /> */}
              中文 (Chinese)
            </li>
            <li onClick={() => handleLanguageSelect('ja')}>
              {/* <img src={japanFlag} alt="Japanese Flag" /> */}
              日本語 (Japanese)
            </li>
            <li onClick={() => handleLanguageSelect('ar')}>
              {/* <img src={arabFlag} alt="Arabic Flag" /> */}
              العربية (Arabic)
            </li>
          </ul>
          <a
            href="https://naver.me/5PVoMP5Y"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.externalLinkButton}
          >
            {i18n.t('common.inquiryHospital')}
          </a>
        </>
      );
    } else {
      return (
        <>
          <form onSubmit={handleSubmit}>
            <h2 className={styles.loginTitle}>
              {i18n.t('hospitalLogin.title')}
            </h2>
            <ul className={styles.loginOptions}>
              <li
                onClick={() => {
                  localStorage.setItem('rurl', redirectURL || '/');
                  window.location.href = LINE_AUTH_URL;
                }}
              >
                <img src={lineIcon} alt="Line Icon" />
                <span>{i18n.t('hospitalLogin.signInWithLine')}</span>
              </li>
              {/* <li>
                <img src={wechatIcon} alt="WeChat Icon" />
                <span>{i18n.t('hospitalLogin.signInWithWeChat')}</span>
              </li>
              <li>
                <img src={whatsappIcon} alt="WhatsApp Icon" />
                <span>{i18n.t('hospitalLogin.signInWithWhatsApp')}</span>
              </li> */}
              <li
                onClick={() => {
                  localStorage.setItem('rurl', redirectURL || '/');
                  window.location.href = GOOGLE_AUTH_URL;
                }}
              >
                <img src={googleIcon} alt="Google Icon" />
                <span>{i18n.t('hospitalLogin.signInWithGoogle')}</span>
              </li>
            </ul>
            <div className={styles.orDivider}>{i18n.t('common.or')}</div>
            <div className={styles.inputContainer}>
              <input
                type="text"
                value={id}
                placeholder={i18n.t('hospitalLogin.usernamePlaceholder')}
                onChange={(e) => setId(e.currentTarget.value)}
                onBlur={() => setId((prev) => prev.trim())}
              />
              <input
                type="password"
                value={pw}
                placeholder={i18n.t('hospitalLogin.passwordPlaceholder')}
                onChange={(e) => setPw(e.currentTarget.value)}
                onBlur={() => setPw((prev) => prev.trim())}
              />
            </div>
            <div className={styles.buttonContainer}>
              <button 
                type="submit"
                className={`${styles.loginButton} ${
                  !isFormValid ? styles.disabled : ""
                }`}
                disabled={!isFormValid}
              >
                {i18n.t('hospitalLogin.loginButton')}
              </button>
            </div>
            <div className={styles.footerLinks}>
              <span onClick={() => navigate("/join")}>{i18n.t('common.signup')}</span> {' '}
              <span onClick={() => {navigate("/findAccount")}}>{i18n.t('common.forgotUsername')}</span> {' '}
              <span onClick={() => {navigate("/findAccount?tab=1")}}>{i18n.t('common.forgotPassword')}</span>
            </div>
          </form>
          <a
            href="https://naver.me/5PVoMP5Y"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.externalLinkButton}
          >
            {i18n.t('common.inquiryHospital')}
          </a>
        </>
      );
    }
  };

  return (
    <>
      <Header selectedTab={selectedTab} onTabChange={handleTabChange} />{' '}
      <div className={styles.welcomePage}>
        <div className={styles.leftPanel}>
          <h1>
            Cheongdam
            <br />
            Secret
            <br />
            <span>for VIP</span>
          </h1>
          <div className={styles.imageWrapper}>
            <img
              src={calendarAndHopitalLogo}
              alt="Calendar And Hospital Icon"
            />
          </div>
        </div>
        <div className={styles.rightPanel}>{renderRightPanelContent()}</div>
      </div>
      <Footer />
    </>
  );
}

export default Welcome;
